/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import identity from 'transmute/identity';
import { createAction } from 'flux-actions';
import getUserId from '../utils/getUserId';
import * as DocumentsPublicApi from '../api/DocumentsPublicApi';
import { MEETINGS_LINK_FETCH_SUCCEEDED } from '../constants/ActionTypes';
const fetchMeetingsLinkSuccess = createAction(MEETINGS_LINK_FETCH_SUCCEEDED, identity);
export const fetchMeetingLink = () => (dispatch, getState) => {
  const userId = getUserId(getState);
  DocumentsPublicApi.fetchMeetingLink(userId).then(({
    link
  }) => dispatch(fetchMeetingsLinkSuccess(link)));
};